/* eslint camelcase: "off" */
import React from "react"
import PropTypes from "prop-types"
import {
  FormContainer,
  InputField,
  StandardModal,
  BirthDatePicker
} from "uikit"
import { Grid, Form, Dropdown } from "semantic-ui-react"

const roleOptions = [
  { text: "Spouse", value: "spouse" },
  { text: "Child", value: "child" }
]

const PersonForm = ({
  data: {
    fields: { first_name, role, birth_date },
    isModified,
    onSubmit,
    isPending,
    hasError,
    error
  },
  submitLabel = "Add This Person",
  submitHeader = "",
  onCancel
}) => (
  <Form
    error={hasError}
    loading={isPending}
    className="AddModal__Form"
    onSubmit={onSubmit}
  >
    <Grid>
      <Grid.Row>
        <Grid.Column>
          <InputField
            autoFocus
            field={first_name}
            label="First Name"
            className="AddModal__FormField"
          />
          <InputField
            field={birth_date}
            label="Birth Date"
            control={BirthDatePicker}
            className="AddModal__FormField"
            error={birth_date.error}
          />
          <InputField
            field={role}
            label="Role in Household"
            placeholder="Select Role"
            options={roleOptions}
            fluid
            selection
            control={Dropdown}
            className="AddModal__FormField AddModal__RoleOptions"
          />
        </Grid.Column>
      </Grid.Row>
    </Grid>
    <button type="submit" style={{ display: "none" }} />
  </Form>
)

const AddPersonFormModal = props => (
  <StandardModal defaultOpen={true} closeOnDimmerClick={false}>
    <StandardModal.Header header="Add Person to Household" />
    <StandardModal.Content>
      <PersonForm {...props} />
    </StandardModal.Content>
    <StandardModal.Actions
      submitLabel="Add This Person"
      cancelLabel="Cancel"
      onSubmit={props.data.onSubmit}
      onCancel={props.onCancel}
      loading={props.data.isPending}
    />
  </StandardModal>
)

export const PERSON_SCHEMA = {
  first_name: {
    type: "string",
    required: true
  },
  birth_date: {
    type: "birthdate",
    required: true
  },
  role: {
    type: "string",
    required: true
  }
}

export const AddPersonModal = FormContainer(PERSON_SCHEMA)(AddPersonFormModal)

AddPersonModal.PropTypes = {
  submit: PropTypes.func,
  onCancel: PropTypes.func
}
